<template>
  <svg :width="width" :height="height" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_d_55_185)">
      <g clip-path="url(#clip0_55_185)">
        <path d="M12 28C12 16.9543 20.9543 8 32 8V8C43.0457 8 52 16.9543 52 28V48H32C20.9543 48 12 39.0457 12 28V28Z" fill="#FAFAFA" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M32 36.996C26.945 36.996 22.863 32.828 23.004 27.741C23.134 23.045 27.049 19.13 31.745 19C36.832 18.859 41 22.941 41 27.996C41 29.353 40.699 30.64 40.162 31.795L41.32 37.338L35.787 36.163C34.635 36.698 33.352 36.996 32 36.996V36.996Z"
          :stroke="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M32.1768 27.8232C32.2744 27.9209 32.2744 28.0791 32.1768 28.1768C32.0791 28.2744 31.9209 28.2744 31.8232 28.1768C31.7256 28.0791 31.7256 27.9209 31.8232 27.8232C31.9209 27.7256 32.0791 27.7256 32.1768 27.8232"
          :stroke="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M36.1768 27.8232C36.2744 27.9209 36.2744 28.0791 36.1768 28.1768C36.0791 28.2744 35.9209 28.2744 35.8232 28.1768C35.7256 28.0791 35.7256 27.9209 35.8232 27.8232C35.9209 27.7256 36.0791 27.7256 36.1768 27.8232"
          :stroke="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M28.1768 27.8232C28.2744 27.9209 28.2744 28.0791 28.1768 28.1768C28.0791 28.2744 27.9209 28.2744 27.8232 28.1768C27.7256 28.0791 27.7256 27.9209 27.8232 27.8232C27.9209 27.7256 28.0791 27.7256 28.1768 27.8232"
          :stroke="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <path d="M52 50H54V48V28C54 15.8497 44.1503 6 32 6C19.8497 6 10 15.8497 10 28C10 40.1503 19.8497 50 32 50H52Z" :stroke="color" stroke-width="4" />
    </g>
    <defs>
      <filter id="filter0_d_55_185" x="0" y="0" width="64" height="64" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="4" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_55_185" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_55_185" result="shape" />
      </filter>
      <clipPath id="clip0_55_185">
        <path d="M12 28C12 16.9543 20.9543 8 32 8V8C43.0457 8 52 16.9543 52 28V48H32C20.9543 48 12 39.0457 12 28V28Z" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  name: 'Icon1',
  props: {
    color: {
      type: String,
      default: '#000',
    },
    width: {
      type: Number,
      default: 96,
    },
    height: {
      type: Number,
      default: 96,
    },
  },
};
</script>
